/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'logout': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2 4.167C2 2.97 2.97 2 4.167 2H10c1.197 0 2.167.97 2.167 2.167v1.666a.5.5 0 01-1 0V4.167C11.167 3.522 10.644 3 10 3H4.167C3.522 3 3 3.522 3 4.167v10c0 .644.522 1.166 1.167 1.166H10c.644 0 1.167-.522 1.167-1.166V12.5a.5.5 0 111 0v1.667c0 1.196-.97 2.166-2.167 2.166H4.167A2.167 2.167 0 012 14.167v-10z" _fill="#1F222C"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M14.647 6.313a.5.5 0 01.707 0l2.5 2.5a.5.5 0 01.108.545l-.003.008a.49.49 0 01-.112.161l-2.493 2.493a.5.5 0 01-.708-.707l1.647-1.646H5.833a.5.5 0 110-1h10.46L14.647 7.02a.5.5 0 010-.707z" _fill="#1F222C"/>'
  }
})
